/*
 * @Descripttion:
 * @Author: 01403240
 * @Date: 2022-01-13 14:30:09
 * @LastEditors: 01403240
 * @LastEditTime: 2022-01-14 15:13:41
 */
// 开具发票模块
const invoice = [
  {
    path: "/invoice",
    name: "invoice",
    redirect: {
      path: "/invoice/notinvoicedorders",
    },
    meta: {
      title: "开具发票-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/invoice/index"),
    children: [
      {
        path: "/invoice/notinvoicedorders",
        name: "notinvoicedorders",
        meta: {
          title: "未开票订单-顺丰科技数字商店",
        },
        component: () =>
          import(
            /* webpackChunkName:'home' */ "@/pages/invoice/NotInvoicedOrders"
          ),
      },
      {
        path: "/invoice/invoicedrecords",
        name: "invoicedrecords",
        meta: {
          title: "开票记录-顺丰科技数字商店",
        },
        component: () =>
          import(
            /* webpackChunkName:'home' */ "@/pages/invoice/InvoicedRecords"
          ),
      },
    ],
  },
  {
    path: "/invoice/invoicedorders/details",
    name: "invoicedordersdetails",
    meta: {
      title: "开具记录详情-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/invoice/InvoicedDetail"),
  },
];

export default invoice;
